import { Vehicle } from "./Vehicle";

export const EquipmentType = {
  BoxingGlove: 'boxingGlove',
  GiantMallet: 'giantMallet',
  SkyWriting: 'skyWriting',
  Ink: 'squidInk',
  SnowBlower: 'snowBlower',

  MagCable: 'magCable',
  Grapple: 'grapple',
  NetSteel: 'netSteel',
  Laser: 'lasers',
  Crane: 'crane'
} as const;

export type EquipmentTypeKeys = keyof typeof EquipmentType;
export type EquipmentTypeValues = typeof EquipmentType[EquipmentTypeKeys];

export abstract class VehicleEquipment extends Phaser.GameObjects.GameObject {
  protected equipmentType: EquipmentTypeValues;

  constructor(scene: Phaser.Scene, equipmentType: EquipmentTypeValues) {
    super(scene, 'vehicleEquipment');

    this.equipmentType = equipmentType;
  }

  get EquipmentType(): EquipmentTypeValues {
    return this.equipmentType;
  }
}
